import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randFlightNumber } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randFlightNumber>[0], undefined>;
type Airline = Exclude<Options["airline"], undefined> | "";

const airlines: Record<Airline, string> = {
  "": "",
  RyanAir: "RyanAir",
  "British Airways": "British Airways",
  Iberia: "Iberia",
  EasyJet: "EasyJet",
  Jet2: "Jet2",
  Emirates: "Emirates",
  "American Airlines": "American Airlines",
  JetBlue: "JetBlue",
  "Air Europa": "Air Europa",
  "Delta Air Lines": "Delta Air Lines",
  "United Airlines": "United Airlines",
  "Thai Airways": "Thai Airways",
  "Qatar Airways": "Qatar Airways",
  "Virgin Atlantic": "Virgin Atlantic",
};

export const randFlightNumberNodeDef = createNodeDef({
  type: "randFlightNumber",
  displayName: "Flight Number",
  defaultName: "flightNumber",
  fields: [
    {
      type: DataFieldType.SELECT,
      key: "airline",
      label: "Airline",
      options: airlines,
    },
  ],
  initialData: (): { airline: Airline } => ({ airline: "" }),
  generate: ({ node }) => {
    return randFlightNumber({ airline: node.data.airline || undefined });
  },
});
